import { render, staticRenderFns } from "./AModalUserSelector.vue?vue&type=template&id=32d64c5e"
import script from "./AModalUserSelector.vue?vue&type=script&lang=js"
export * from "./AModalUserSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports